import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import managementStyles from '../ManagementPages.module.css';
import DeviceInformationContent from './DeviceInformationContent';
import { LeftArrowIcon } from '../../components/icons/Icons';

const DeviceInformation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [deviceData, setDeviceData] = useState(location.state?.deviceData || {});

    const onBackHandler = () => {
        navigate(-1);
    };

    const handleDeviceUpdate = (updatedData) => {
        setDeviceData(updatedData);
    };

    return (
        <>
            <div className="selectedMenuItemBack" onClick={onBackHandler}>
                <LeftArrowIcon />
                <span>Back to Assignments</span>
            </div>
            <div className={managementStyles.GridContainer}>
                <DeviceInformationContent 
                    deviceData={deviceData} 
                    onUpdate={handleDeviceUpdate}
                />
            </div>
        </>
    );
};

export default DeviceInformation; 